<template>
  <div class="template-coordinate">
    <div class="tc-btn">
      <i :class="`el-icon-location ${runStateClass} ${seletedTypeClass}`"
         @click="clickCoordinate"
         style="display: block;font-size: 32px;"></i>
      <div class="device-card"
           v-if="showDeviceInfo"
           @mousedown.stop=""
           @click.stop="">
        <p>
          <em>{{ $t('terminal.deviceName') }}:</em>
          <span>{{myData.name}}</span>
        </p>
        <p>
          <em>{{ $t('terminal.cacc2') }}:</em>
          <span>{{myData.group_name}}</span>
        </p>
        <p>
          <em>{{ $t('terminal.cacc3') }}:</em>
          <span>{{myData.size_remark | formatNoData}}</span>
        </p>
        <p>
          <em>{{ $t('terminal.cacc4') }}:</em>
          <span>{{myData.space | formatNoData}}</span>
        </p>
        <p>
          <em>{{ $t('terminal.cacc5') }}:</em>
          <span>{{myData.system_version | formatNoData}}</span>
        </p>
        <p>
          <em>{{ $t('terminal.cacc6') }}:</em>
          <span>{{myData.remark1 | formatNoData}}</span>
        </p>
        <p>
          <em>{{ $t('terminal.cacc7') }}:</em>
          <span v-if="myData.run_state !== ''"
                :style="'color:'+myData.runStateInfo.stateColor">
<!--            {{runState[myData.run_state].name}}-->
            {{myData.runStateInfo.stateName}}
          </span>
        </p>
        <p>
          <em>{{ $t('terminal.cacc8') }}:</em>
          <span>{{myData.uptimeMills | formatNoData}}</span>
        </p>
        <p>
          <em>{{ $t('terminal.cacc9') }}:</em>
          <span>{{myData.last_heartbeat | formatNoData}}</span>
        </p>
        <p>
          <em>{{ $t('terminal.cacc10') }}:</em>
          <span>{{myData.time | formatNoData}}</span>
        </p>
        <p>
          <em>{{ $t('terminal.cacc11') }}:</em>
          <span>{{myData.remoteAddr | formatNoData}}</span>
        </p>
        <div class="dc-voice">
          <em>{{ $t('terminal.cacc12') }}:</em>
          <div v-if="myData.voice">
            <el-slider v-model="myData.voice" class="dc-slider" @change="changeValue('voice')"></el-slider>
            <el-input :value="myData.voice"
                      size="mini" class="dc-input" max="100" step
                      @input="inputValue('voice', $event)"></el-input>
          </div>
          <div v-else>
            <span>{{$t('terminal.noData') }}</span>
          </div>
        </div>
        <div class="dc-bright">
          <em>{{ $t('terminal.cacc14') }}:</em>
          <div v-if="myData.bright">
            <el-slider v-model="myData.bright" class="dc-slider" @change="changeValue('bright')"></el-slider>
            <el-input :value="myData.bright" size="mini" class="dc-input" max="100"
                      @input="inputValue('bright', $event)"></el-input>
          </div>
          <div v-else>
            <span>{{$t('terminal.noData') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // import { handleDataAndSign } from "@/common/scripts/handleDataAndSign";
  import { openSuccessInit } from "@/assets/scripts/webSocket";
  import { formatDate } from "@/assets/scripts/formatDate";
  import { formatHMS } from "@/assets/scripts/publicFunction";
  import { runStateInfo } from "@/assets/scripts/runState";

  // const DEVICEINFO_URI = "/admin/device/detail";

  export default {
    name: "coordinate",
    props: {
      keyDownCtrl: {
        type: Boolean,
        default: false
      },
      showDeviceInfo: {
        type: Boolean,
        default: false
      },
      deviceInfo: {
        type: Object,
        default() {
          return {};
        }
      },
      activeIndex: {
        type: Number,
        default: -1
      },
      myVid: {
        type: Number
      },
      switchButton: {
        type: Boolean,
        default: true
      },
      pickedInRegion: {
        type: Boolean,
        default: false
      },
      isAmapSingle: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        value2: 10,
        myData: {
          name: '',
          group_name: '',
          run_state: '',
          size_remark: '',
          remark1: '',
          remark2: '',
          space: '',
          system_version: '',
          group_run_status: null,
          runStateInfo: {}
        },
        loading: false,
        seletedTypeClass: '',
        WS: {
          loadingTimer: null,
          wsShow: false,
          commandParams: null
        }
      };
    },
    methods: {
      clickCoordinate() {
      },
      getDeviceInfo(n) {
        console.log(n, this.deviceInfo, this.$store.getters.userInfo);
        // this.WS.wsShow = false;
        this.myData.name = this.deviceInfo.name;
        this.myData.group_name = this.$store.getters.groupIdName[this.deviceInfo.group_id];
        this.myData.run_state = Number(this.deviceInfo.run_state);
        this.myData.size_remark = this.deviceInfo.size_remark;
        this.myData.remark1 = this.deviceInfo.remark1;
        this.myData.remark2 = this.deviceInfo.remark2;
        this.myData.last_heartbeat = formatDate(new Date(Number(this.deviceInfo.last_heartbeat) * 1000), "yyyy-MM-dd hh:mm:ss");
        // this.myData.last_heartbeat = this.deviceInfo.last_heartbeat;
        this.myData.space = `${(Number(this.deviceInfo.usablespace) / 1024).toFixed(2)}G / ${(Number(this.deviceInfo.totalspace) / 1024).toFixed(2)}G`;
        this.myData.system_version = this.deviceInfo.system_version;
        this.myData.group_run_status = this.deviceInfo.group_run_status;
        this.myData.runStateInfo = runStateInfo(this.deviceInfo.run_state, this.deviceInfo.group_run_status);
        console.log('runStateInfo---->', this.myData.runStateInfo);
        // let params = {
        //   id: this.deviceInfo.id,
        //   sn: this.deviceInfo.sn,
        //   token: getCookie('token')
        // };
        n && this.goMyWebSocket(this.WS.commandParams);
        // if (this.showDeviceInfo) {
        //   let deviceIdData = handleDataAndSign(DEVICEINFO_URI, { id: this.deviceInfo.id });
        //   this.$api.post(DEVICEINFO_URI, deviceIdData, response => {
        //     if (response.status >= 200 && response.status < 300) {
        //       let res = response.data;
        //       if (res.status === 1) {
        //         let info = res.data;
        //         this.myData.name = info.name;
        //         this.myData.group_name = info.group_name;
        //         this.myData.run_state = Number(info.run_state);
        //         this.myData.size_remark = info.size_remark;
        //         this.myData.remark1 = info.remark1;
        //         this.myData.remark2 = info.remark2;
        //         this.myData.space = `${(Number(info.usablespace) / 1024).toFixed(2)}G / ${(Number(info.totalspace) / 1024).toFixed(2)}G`;
        //         this.myData.system_version = info.system_version;
        //         this.loading = false;
        //       } else {
        //         this.$elementMessage(res.tips, "warning");
        //         this.loading = false;
        //       }
        //     } else {
        //       this.$elementMessage("未知错误", "warning");
        //       this.loading = false;
        //       return false;
        //     }
        //   });
        // }
      },
      goMyWebSocket(deviceInfo) {
        // let thisVue = this;
        let msg = {
          role: 'web',
          from: 'device_command_get',
          data: {
            deviceInfo: deviceInfo,
            requestCommandList: ['get_device_info']
          }
        };
        let cloneRequestCommandList = JSON.parse(JSON.stringify(msg.data.requestCommandList));
        // this.WS.loadingTimer = setTimeout(function () {
        //   thisVue.loading = false;
        // }, 5000);
        switch (this.myWebSocket.readyState) {
          case 0:
            this.myWebSocket.onopen = () => {
              openSuccessInit(this);
              this.myWebSocket.send(JSON.stringify(msg));
            };
            break;
          case 1:
            this.myWebSocket.send(JSON.stringify(msg));
            break;
          case 2:
            break;
          case 3:
            break;
          default:
            break;
        }
        this.myWebSocket.onmessage = (value) => {
          let info = JSON.parse(value.data);
          switch (info.type) {
            case 'get_device_info':
              this.formatGetDeviceInfo(cloneRequestCommandList, info, this);
              // this.WS.wsShow = true;
              // console.log(this.amapData);
              break;
            case 'get_setting_schedule':
              this.formatGetSettingSchedule(cloneRequestCommandList, info, this);
              break;
            default:
              break;
          }
          // if (!cloneRequestCommandList.length) {
          //   thisVue.loading = false;
          //   clearTimeout(this.WS.loadingTimer);
          // }
        };
      },
      formatGetDeviceInfo(cloneRequestCommandList, info, thisVue) {
        cloneRequestCommandList.splice(cloneRequestCommandList.indexOf('get_device_info'), 1);
        thisVue.myData.space = `${(info.data.device.usableSpace / 1024).toFixed(2)}G / ${(info.data.device.totalSpace / 1024).toFixed(2)}G`;
        thisVue.myData.deviceVersion = `V${info.data.device.systemVersion}-${info.data.device.appVersion}`;
        thisVue.myData.run_state = info.data.status;
        thisVue.myData.time = formatDate(new Date(info.data.time), "yyyy-MM-dd hh:mm:ss");
        thisVue.myData.uptimeMills = formatHMS(info.data.uptimeMills, ':', false, false);
        thisVue.myData.remoteAddr = info.data.device.remote_addr;
        this.$set(this.myData, 'voice', info.data.device.voice * 100);
        this.$set(this.myData, 'bright', info.data.bright);
        this.myData.runStateInfo = runStateInfo(this.deviceInfo.run_state, this.deviceInfo.group_run_status);
        thisVue.deviceInfoShow = true;
        console.log(thisVue.myData, thisVue.myData.runStateInfo);
      },
      changeValue(type) {
        let value = null;
        switch (type) {
          case 'voice':
            console.log('voice--->', this.myData.voice);
            value = parseFloat(this.myData.voice / 100);
            break;
          case 'bright':
            console.log('bright--->', this.myData.bright);
            value = this.myData.bright;
            break;
        }
        console.log(this.myWebSocket.readyState);
        this.sendSetting(type, value);
      },
      inputValue(type, event) {
        if (isNaN(Number(event)) || Number(event) < 0 || Number(event) > 100) {
          this.$elementMessage(this.$t('cacc15'), 'warning');
          return;
        }
        let value = null;
        switch (type) {
          case 'voice':
            this.myData.voice = Number(event);
            value = parseFloat(this.myData.voice / 100);
            break;
          case 'bright':
            this.myData.bright = Number(event);
            value = this.myData.bright;
            break;
        }
        console.log('type---->', event, type);
        this.sendSetting(type, value);
      },
      sendSetting(type, value) {
        let msg = {
          role: 'web',
          from: 'device_command_set',
          data: {
            deviceInfo: this.WS.commandParams,
            requestCommand: type,
            value: value
          }
        };
        if (this.myWebSocket.readyState === 1) {
          this.myWebSocket.send(JSON.stringify(msg));
        } else {
          this.$elementMessage(this.deviceInfo.name + '未在线！', 'warning');
        }
      }
    },
    created() {
      // console.log('myData------->', this.myData);
      this.myData.run_state = this.deviceInfo.run_state;
      this.WS.commandParams = {
        id: this.deviceInfo.id,
        sn: this.deviceInfo.sn,
        token: this.$cookies.get('token')
      };
    },
    computed: {
      runStateClass() {
        console.log("this.myData----->", this.myData);
        if (this.isAmapSingle) {
          return 'location-offline';
        } else {
          runStateInfo(this.myData.run_state, this.myData.group_run_status);
          if (Number(this.myData.group_run_status)) {
            if (this.myData.run_state & 1) {
              return 'location-online';
            } else {
              return 'location-offline';
            }
          } else {
            return 'location-limitation';
          }
        }
      },
      myWebSocket() {
        return this.$store.getters.myWebSocket;
      }
    },
    filters: {
      formatNoData(value) {
        !value && (value = '暂无数据');
        return value;
      }
    },
    watch: {
      showDeviceInfo: {
        immediate: true,
        handler(n, o) {
          console.log(this);
          !this.isAmapSingle && this.getDeviceInfo(n, o);
        }
      },
      switchButton() {
        if (!this.keyDownCtrl) {
          // console.log('as-------------->', this.keyDownCtrl);
          this.activeIndex === this.myVid
            ? this.seletedTypeClass === 'location-active'
            ? this.seletedTypeClass = ''
            : this.seletedTypeClass = 'location-active'
            : this.seletedTypeClass = '';
        } else {
          if (this.activeIndex === this.myVid) {
            this.seletedTypeClass !== 'multi-selected'
              ? this.seletedTypeClass = 'multi-selected'
              : this.seletedTypeClass = '';
          } else {
            this.seletedTypeClass === 'location-active' && (this.seletedTypeClass = '');
          }
          this.showDeviceInfo && this.$emit('closeDeviceCard', {myVid: this.myVid, showDeviceInfo: false});
        }
      },
      seletedTypeClass(n) {
        let data = {deviceId: this.deviceInfo.id};
        switch (n) {
          case 'multi-selected':
          case 'location-active':
            data.type = 1;
            // this.$emit('selectedDeviceId', data);
            break;
          case '' :
            data.type = 0;
            // this.$emit('selectedDeviceId', data);
            break;
        }
        let deviceIdTemp = this.$store.getters.multipleId;
        deviceIdTemp = deviceIdTemp ? deviceIdTemp.split(',') : [];
        if (data.type) {
          deviceIdTemp.push(data.deviceId);
        } else {
          deviceIdTemp = deviceIdTemp.filter(item => {
            return item !== data.deviceId;
          });
        }
        deviceIdTemp = new Set(deviceIdTemp);
        this.$store.commit('MULTIPLEID_COORDINATE_LIST', Array.from(deviceIdTemp).join(','));
      },
      pickedInRegion(n) {
        // console.log("this.deviceInfo.name-------------->", this.deviceInfo.name, n);
        let data = {deviceId: this.deviceInfo.id};
        if (n) {
          this.seletedTypeClass = 'multi-selected';
          this.$emit('closeDeviceCard', {myVid: this.myVid, showDeviceInfo: false});
          data.type = 1;
          // this.$emit('selectedDeviceId', data);
        } else {
          this.seletedTypeClass !== 'location-active' && (this.seletedTypeClass = '');
          data.type = 0;
          // this.$emit('selectedDeviceId', data);
        }
      }
    },
    beforeDestroy() {
      this.$store.commit('MULTIPLEID_COORDINATE_LIST', '');
    }
  };
</script>

<style lang="scss" scoped>
  div,span,p{
    box-sizing: border-box;
  }
  .template-coordinate{
    .tc-btn{
      position: relative;
      /*离线状态*/
      i.location-offline{
        color: #8d1528;
      }
      /*选中离线状态*/
      i.location-offline.location-active{
        color: #0060b9;
      }
      /*多选离线状态*/
      i.location-offline.multi-selected{
        color: #720c99;
      }
      /*动画配置*/
      i.location-online,i.location-active,i.multi-selected,i.location-limitation {
        -webkit-animation-duration: 4s;
        animation-duration: 4s;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both;
        -webkit-animation-iteration-count: infinite;
        animation-iteration-count: infinite;
      }
      /*在线状态*/
      i.location-online{
        -webkit-animation-name: location-online;
        animation-name: location-online
      }
      /*选中在线状态*/
      i.location-online.location-active{
        -webkit-animation-name: location-active;
        animation-name: location-active
      }
      /*多选在线状态*/
      i.location-online.multi-selected{
        -webkit-animation-name: multi-selected;
        animation-name: multi-selected
      }
      /*受限状态*/
      i.location-limitation{
        -webkit-animation-name: location-limitation;
        animation-name: location-limitation
      }
      /*选中受限状态*/
      i.location-limitation.location-active{
        -webkit-animation-name: location-active;
        animation-name: location-active
      }
      /*多选受限状态*/
      i.location-limitation.multi-selected{
        -webkit-animation-name: multi-selected;
        animation-name: multi-selected
      }

      @-webkit-keyframes location-online {
        0% {
          color: #1f8700;
        }
        50% {
          color: #46d224;
        }
        100% {
          color: #1f8700;
        }
      }
      @keyframes location-online {
        0% {
          color: #1f8700;
        }
        50% {
          color: #46d224;
        }
        100% {
          color: #1f8700;
        }
      }
      @-webkit-keyframes location-limitation {
        0% {
          color: #875e3a;
        }
        50% {
          color: #c5927c;
        }
        100% {
          color: #875e3a;
        }
      }
      @keyframes location-limitation {
        0% {
          color: #875e3a;
        }
        50% {
          color: #c5927c;
        }
        100% {
          color: #875e3a;
        }
      }
      @-webkit-keyframes location-active {
        0% {
          color: #0060b9;
        }
        50% {
          color: #3b96e8;
        }
        100% {
          color: #0060b9;
        }
      }
      @keyframes location-active {
        0% {
          color: #0060b9;
        }
        50% {
          color: #3b96e8;
        }
        100% {
          color: #0060b9;
        }
      }
      @-webkit-keyframes multi-selected {
        0% {
          color: #720c99;
        }
        50% {
          color: #bd52ea;
        }
        100% {
          color: #720c99;
        }
      }
      @keyframes multi-selected {
        0% {
          color: #720c99;
        }
        50% {
          color: #bd52ea;
        }
        100% {
          color: #720c99;
        }
      }

      i.location-forbidden{
        color: #db1e3d;
      }
      .device-card{
        &:before{
          content: '';
          position: absolute;
          left: -5px;
          top: 83px;
          z-index: 2;
          padding: 6px;
          box-shadow: -1px 2px 3px -3px #000;
          transform:rotate(45deg);
          -ms-transform:rotate(45deg);
          -moz-transform:rotate(45deg);
          -webkit-transform:rotate(45deg);
          -o-transform:rotate(45deg);
          background: #fff;
        }
        position: absolute;
        z-index: 3;
        top: -75px;
        left: 36px;
        width: 240px;
        padding: 18px 16px;
        background: #fff;
        border-radius: 5px;
        box-shadow: 1px 1px 4px -1px #000;
        p{
          display: flex;
          font-size: 14px;
          padding: 1px 0;
          line-height: 1.4em;
          em{
            font-style: normal;
            width: 70px;
            flex-shrink: 0;
            text-align: right;
          }
          span{
            flex-grow: 1;
          }
        }
        div.dc-voice,div.dc-bright{
          display: flex;
          font-size: 14px;
          align-items: center;
          line-height: 1.4em;
          em{
            font-style: normal;
            width: 70px;
            text-align: right;
            flex-shrink: 0;
          }
          &>div{
            flex-grow: 1;
            display: flex;
            align-items: center;
            >>>.dc-slider{
              width: 70%;
              padding-right: 14px;
              flex-shrink: 0;
              .el-slider__button-wrapper{
                div{
                  width: 12px;
                  height: 12px;
                }
              }
            }
            >>>.dc-input{
              input{
                padding: 0 6px;
                text-align: center;
              }
            }
          }
        }
      }
    }
  }
</style>
